import script from "./StepPatientForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StepPatientForm.vue?vue&type=script&setup=true&lang=js"

import "./StepPatientForm.vue?vue&type=style&index=0&id=55cc2ebe&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55cc2ebe"]])

export default __exports__